/* global YT */

const Cookies = require('js-cookie');

const moment = require('../../util/date');

const COOKIE_NAMES = {
    CONSTITUENCIES: 'edu_u_constituencies',   // Unencrypted cookie set in BO
    ENCRYPTED_CONSTITUENCIES: 'edu_constituencies',   // Encrypted cookie set in BO
    ENCRYPTED_SPECIAL_RESOURCES: 'edu_special_resources',
    SPECIAL_RESOURCES: 'edu_u_special_resources',
};

function controller($attrs, $interval, $timeout, $http, $element, appConfig) {
    const vm = this;

    vm.STATE_BUTTON = 'button';
    vm.STATE_LOADING = 'loading';
    vm.STATE_READY = 'ready';

    vm.logged_in = !!Cookies.get('_bo_logged_in');
    vm.is_free = $attrs.isFree !== undefined;
    vm.accessed_via_share = false;
    vm.access_constituencies = $attrs.constituencies ? $attrs.constituencies.split(',') : [];
    vm.locked = true;
    vm.loading = true;
    vm.link = $attrs.baseLink;
    vm.resource_expires_timer = '';
    vm.share_link = '';
    vm.share_copied = false;
    vm.state = vm.STATE_BUTTON;
    vm.has_clipboard = !!navigator.clipboard;
    vm.source_url = '';
    vm.video_player = false;
    vm.has_education_constituencies = false;

    vm.copyShareLink = () => {
        navigator.clipboard.writeText(vm.share_link)
            .then(() => {
                vm.share_copied = true;
            });
    };

    vm.generateLink = () => {
        vm.state = vm.STATE_LOADING;
        $http.get(`${appConfig.boURL}/edu/generate-resource-link/v/${$attrs.shareData}}`, { withCredentials: true })
            .then(resourceLinkData => {
                vm.share_link = resourceLinkData.data.response;
                vm.state = vm.STATE_READY;
                const expiration = moment.moment(resourceLinkData.data.expirationDate.date);

                const intervalPromise = $interval(() => {
                    const now = moment.moment();
                    vm.resource_expires_timer = expiration.from(now);

                    if (expiration.isBefore(now)) {
                        vm.resource_expires_timer = '';
                        vm.state = vm.STATE_BUTTON;
                        $interval.cancel(intervalPromise);
                    }
                }, 500);
            })
            .catch(err => {
                console.error('Failed to generate Shareable link', err);
                vm.state = vm.STATE_BUTTON;
            });
    }

    vm.track = () => {
        if ($attrs.accessData) {
            return $http.get(`${appConfig.boURL}/edu/add-tracking/${$attrs.accessData}`, { withCredentials: true });
        }
    }

    vm.trackAndAccess = ev => {
        ev.preventDefault();

        // Track the event to BO and then
        return vm.track()
            .then(response => {
                if (response.data.success === true || vm.is_free) {
                    window.location = ev.currentTarget.href;
                } else {
                    throw response.error;
                }
            })
            .catch(err => {
                alert((err || 'Unknow error occurred') + '\nRe-logging in will hopefully resolve this issue');
            });
    }

    vm.loadAndPlay = () => {
        vm.loading = true;
        const encryptedConstituenciesString = Cookies.get(COOKIE_NAMES.ENCRYPTED_CONSTITUENCIES);
        const encryptedSpecialResourcesString = Cookies.get(COOKIE_NAMES.ENCRYPTED_SPECIAL_RESOURCES);

        switch ($attrs.blockType) {
            case 'audio': {
                $element.find('audio').each((idx, el) => {
                    el.addEventListener('play', vm.track);
                });
                break;
            }
        }

        $http.get(`${$attrs.assetDataBaseUrl}${encryptedConstituenciesString}/${encryptedSpecialResourcesString}`)
            .then(data => data.data)
            .then(data => {
                switch ($attrs.blockType) {
                    case 'audio': {
                        if (data.source) {
                            vm.source_url = data.source;
                            $timeout(() => {
                                // Play audio
                                $element.find('audio')
                                    .get(0)
                                    .play();
                            }, 100);
                        }

                        break;
                    }

                    case 'video': {
                        switch(data.type) {
                            case 'youtube': {
                                return embedYouTube(data.code);
                            }
                        }

                        break;
                    }
                }
            })
            .finally(() => {
                vm.loading = false;
            })
    }

    vm.onYouTubePlayerReady = ev => {
        ev.target.playVideo();
        vm.track();
    }

    /**
     * Assumes the iframe_api JS is loaded in <head> of Page.ss
     *
     * @param {string} code
     * @returns {Promise}
     */
    function embedYouTube(code) {
        return new Promise(resolve => {     // eslint-disable-line
            vm.video_player = new YT.Player(`video-${$attrs.blockItem}`, {
                height: 390,
                width: 640,
                videoId: code,
                playerVars: {
                    playsinline: 1,
                },
                events: {
                    onReady: event => {
                        vm.onYouTubePlayerReady(event);
                        resolve()
                    },
                }
            });
        });
    }

    vm.init = () => {
        if (vm.is_free) {
            vm.locked = false;
        } else {
            let constituencies = Cookies.get(COOKIE_NAMES.CONSTITUENCIES);
            let specialAccess = Cookies.get(COOKIE_NAMES.SPECIAL_RESOURCES);
            const encryptedConstituenciesString = Cookies.get(COOKIE_NAMES.ENCRYPTED_CONSTITUENCIES);
            const encryptedSpecialResourcesString = Cookies.get(COOKIE_NAMES.ENCRYPTED_SPECIAL_RESOURCES);
            vm.link = `${$attrs.baseLink}/${encryptedConstituenciesString}/${encryptedSpecialResourcesString}`;
            constituencies = constituencies ? constituencies.split(',') : [];
            specialAccess = specialAccess ? specialAccess.split(',') : [];
            const educationConstituencies = $attrs.educationConstituencies ? $attrs.educationConstituencies.split(',') : [];

            vm.locked = specialAccess.indexOf($attrs.pageId) === -1;
            vm.accessed_via_share = !vm.locked;

            constituencies.forEach(code => {
                if (educationConstituencies.indexOf(code) > -1) {
                    vm.has_education_constituencies = true;
                }
            });

            vm.access_constituencies.forEach(code => {
                if (constituencies.indexOf(code) !== -1) {
                    vm.locked = false;
                    vm.accessed_via_share = false;
                }
            });
        }

        if (!vm.locked) {
            // If the page is un-locked then adds the class so th content can be viewed
            document.querySelector('.global-container').classList.add('global-container--education-page-has-access');

            if ($attrs.trackOnAccess) {
                vm.track();
            }
        }

        vm.loading = false;
    }

    return vm;
}

module.exports = [
    '$attrs',
    '$interval',
    '$timeout',
    '$http',
    '$element',
    'appConfig',
    controller,
];
